export default "__VITE_ASSET___iYXrA$5__"